export default "<div class='user-form-container'>\n  <app-user-form></app-user-form>\n</div>"